export default "__VITE_ASSET__DtzHwQE2__"